import type { StatusChannel } from "@rubi/ui";

export enum ReportStatus {
  draft = "draft",
  modification_requested = "modification_requested",
  modification_opted = "modification_opted",
  submitted = "submitted",
  resubmitted = "resubmitted",
  approved = "approved",
  rejected = "rejected",
  escalated = "escalated",
  pending_deletion = "pending_deletion",
  pending_deletion_public = "pending_deletion_public",
}

export const statusTypes: { [key in ReportStatus]: string } = {
  draft: "Draft",
  modification_requested: "Awaiting Response",
  modification_opted: "Modification Opted",
  submitted: "New",
  resubmitted: "Resubmitted",
  approved: "Approved",
  rejected: "Rejected",
  escalated: "Escalated",
  pending_deletion: "Pending Deletion",
  pending_deletion_public: "Pending Deletion (Public)",
};

// Drafts and soft-deletes are never shown on non-police surfaces; the backend applies the same
// filter, so offering them would only ever yield empty results.
export const HIDDEN_STATUSES: ReportStatus[] = [
  ReportStatus.draft,
  ReportStatus.pending_deletion,
  ReportStatus.pending_deletion_public,
];

export const getStatusOptions = (exclude: ReportStatus[] = []): string[] =>
  Object.keys(statusTypes)
    .filter((status) => !exclude.includes(status as ReportStatus))
    .sort((a, b) => statusTypes[a].localeCompare(statusTypes[b]));

export const reportStatusTooltips: { [key in ReportStatus]: string } = {
  approved:
    "The report has been approved. The reporting party has been notified by email. The report has been exported to RMS and DEMS (if configured).",
  rejected:
    "The report has been rejected. The reporting party has been notified by email. The report was not exported to RMS or DEMS.",
  submitted: "A newly submitted report awaiting review.",
  escalated:
    "The report requires immediate police response. The reporting party has been notified by email. It has been escalated and exported to RMS and DEMS (if configured).",
  resubmitted:
    "The reporting party updated and resubmitted the report after a follow-up request.",
  modification_requested:
    "Additional information was requested from the reporting party. Waiting for their response.",
  draft: "A draft report that has not been submitted.",
  modification_opted:
    "The reporting party has opted not to provide the requested modifications.",
  pending_deletion:
    "The report is pending deletion and will no longer be available once removed.",
  pending_deletion_public:
    "The public version of this report is pending deletion and will no longer be available once removed.",
};

export const reportColourTypes: {
  [key in ReportStatus]: StatusChannel;
} = {
  draft: "statusDraft",
  modification_requested: "statusModificationRequested",
  modification_opted: "statusModificationOpted",
  submitted: "statusSubmitted",
  resubmitted: "statusResubmitted",
  approved: "statusApproved",
  rejected: "statusRejected",
  escalated: "statusEscalated",
  pending_deletion: "statusPendingDeletion",
  pending_deletion_public: "statusPendingDeletionPublic",
};

export const priorityColourTypes: {
  [key: string]: any;
} = {
  "0": "info",
  "1": "success",
  "2": "success",
  "3": "success",
  "4": "warning",
  "5": "warning",
  "6": "warning",
  "7": "error",
  "8": "error",
  "9": "error",
};
